import { render, staticRenderFns } from "./user.vue?vue&type=template&id=60c14568"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c14568')) {
      api.createRecord('60c14568', component.options)
    } else {
      api.reload('60c14568', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=60c14568", function () {
      api.rerender('60c14568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/users/user.vue"
export default component.exports